module.exports = __webpack_public_path__ + "img/stwo.7ccff49d.png";